import { Control, Controller, FieldPath } from 'react-hook-form'

import { Checkbox } from '@/components/ui'
import FormGroup from '@/core/components/FormGroup'

import { IArtistValues } from './types'

export const ArtistCheckboxField = ({
  name,
  label,
  control,
}: {
  name: FieldPath<IArtistValues>
  label: string
  control: Control<IArtistValues>
}) => (
  <FormGroup
    label={label}
    direction="row"
    labelClassName="whitespace-nowrap"
    inputWrapperClassName="w-auto"
    wrapperClassName="w-auto flex-row-reverse justify-end"
  >
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Checkbox
          className="h-[15px] w-[15px] rounded-[3.75px] border-monochrome-1"
          checked={Boolean(field.value)}
          onCheckedChange={(checked) => field.onChange(Boolean(checked))}
        />
      )}
    />
  </FormGroup>
)
